import qs from 'qs';
import request from '@/lib/request';
import { TagCategory } from '@/types/tags';

type Response = {
  data: TagCategory[];
  meta: any;
};

export default async function getTagsCategory(options?: {
  locale: string;
  baseUrl?: boolean;
}) {
  const query = qs.stringify(
    {
      locale: options?.locale,
      populate: {
        tags: true,
      },
    },

    {
      encodeValuesOnly: true,
    }
  );

  return await request<Response>('GET', `/api/tags-categories?${query}`, {
    baseUrl: options?.baseUrl,
  });
}
